import { ParsedUrlQuery } from "querystring";

export const filtersMap = {
  transportation: "cars",
  "online-tours": "online-experiences",
} as { [key: string]: string };

const removePageParam = (query: ParsedUrlQuery) => {
  // Create a copy of the query object
  const newQuery = { ...query };

  // Check if the 'page' parameter is '1' and remove it
  if (newQuery.page === "1") {
    delete newQuery.page;
  }

  return newQuery;
};

/**
 * Build canonical url
 * @param query
 * @returns url
 */
export const buildCanonical = async (query: ParsedUrlQuery) => {
  let url = "/s";
  if (query) {
    const updatedQuery = removePageParam(query);

    const urlParams = new URLSearchParams(
      Object.entries(updatedQuery as Record<string, string>)
    ).toString();

    url = `${url}?${urlParams}`;
    return url;
  }

  return "";
};

export const checkNoIndexNoFollow = (url: string) => {
  return (
    url.includes("date=") ||
    url.includes("adults=") ||
    url.includes("children=") ||
    url.includes("infants=") ||
    url.includes("q=")
  );
};
